import { PokemonSet } from '../types/pokemon';

// Transform the fetched Pokemon TCG data into our app format
export const loadMasterSets = (data: any[] = []): PokemonSet[] => {
  return data
    .map((set: any) => ({
      id: set.id,
      name: set.name,
      series: set.series,
      printedTotal: set.printedTotal || set.totalCards,
      totalCards: set.totalCards || set.printedTotal || 0,
      releaseDate: set.releaseDate,
      images: {
        symbol: set.images?.symbol || '',
        logo: set.images?.logo || set.images?.symbol || '',
      },
      era: set.era || 'Unknown Era',
      valueTier: set.estimatedValue || 'Standard ($5-25 avg card)',
      owned: 0,
      completion: 0, // Will be calculated
    }))
    .map((set: PokemonSet) => ({
      ...set,
      completion:
        set.printedTotal > 0 ? (set.owned / set.printedTotal) * 100 : 0,
    }));
};

// Get unique eras for filtering
export const getUniqueEras = (sets: PokemonSet[]): string[] => {
  const eras = Array.from(new Set(sets.map((set) => set.era)));
  return eras.sort();
};

// Get unique series for filtering
export const getUniqueSeries = (sets: PokemonSet[]): string[] => {
  const series = Array.from(new Set(sets.map((set) => set.series)));
  return series.sort();
};

// Filter and sort sets
export const filterAndSortSets = (
  sets: PokemonSet[],
  searchTerm: string,
  eraFilter: string,
  seriesFilter: string,
  sortBy: string,
  sortDirection: 'asc' | 'desc',
  selectedTab: number
): PokemonSet[] => {
  let filtered = sets.filter((set) => {
    const matchesSearch =
      set.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      set.series.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesEra = eraFilter === 'all' || set.era === eraFilter;
    const matchesSeries = seriesFilter === 'all' || set.series === seriesFilter;

    return matchesSearch && matchesEra && matchesSeries;
  });

  // Apply tab filter
  if (selectedTab === 1) {
    filtered = filtered.filter(
      (set) => set.completion > 0 && set.completion < 100
    );
  } else if (selectedTab === 2) {
    filtered = filtered.filter((set) => set.completion === 100);
  } else if (selectedTab === 3) {
    filtered = filtered.filter((set) => set.completion === 0);
  }

  // Sort sets with direction
  return filtered.sort((a, b) => {
    let comparison = 0;

    switch (sortBy) {
      case 'name':
        comparison = a.name.localeCompare(b.name);
        break;
      case 'releaseDate':
        comparison =
          new Date(a.releaseDate).getTime() - new Date(b.releaseDate).getTime();
        break;
      case 'completion':
        comparison = a.completion - b.completion;
        break;
      case 'series':
        comparison = a.series.localeCompare(b.series);
        break;
      default:
        comparison =
          new Date(a.releaseDate).getTime() - new Date(b.releaseDate).getTime();
        break;
    }

    return sortDirection === 'asc' ? comparison : -comparison;
  });
};
